import { RequestResults } from "../redux/common/RequestStatus";

export interface DeleteReason {
    id?: string;
    reason?: string;
    status?: number;
    type?: ReasonType;
    showInPortal?: boolean;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
}

export enum ReasonType {
    Lost = 1,
    Found = 2
}

export enum ReasonStatus {
    Active = 1,
    DiActive = 0
}

export interface DeleteReasonState {
    data: DeleteReason[];
    status: RequestResults;
    loading: boolean;
    error: string | null;
}

export const NotFoundReason = "Not Found";